import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppFilter } from '@app/shared/models';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';

@Component({
  selector: 'app-activating-e-wallet',
  templateUrl: './activating-e-wallet.component.html',
  styleUrls: ['./activating-e-wallet.component.scss'],
})
export class ActivatingEWalletComponent {
  pending: boolean = false;
  error: any;
  organization;
  success;
  user;
  filter = new AppFilter({
    sidx: 'walletCreatedDate',
    sord: 'asc',
    _search: false,
  });
  constructor(
    private router: Router,
    private location: Location,
    private walletService: EwalletService
  ) {
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.user['totpEnabled']
      ? this.getBalances()
      : this.router.navigate(['/contractor/wallet']);
  }
  getBalances() {
    this.pending = true;
    const user = JSON.parse(localStorage.getItem('user'));
    const nccId = user.organizationId.jpaContractor.nccId;
    this.walletService
      .getBalances({
        params: {
          ...this.filter,
          nccId,
        },
      })
      .subscribe(
        (res: any) => {
          const hasActiveStatus = res.rows.some(
            (item) => item.companyWalletActive
          );
          if (hasActiveStatus) {
            this.router.navigate(['/contractor/wallet/accounts']);
          } else {
            this.getWalletDetails();
            // this.pending = false;
          }
        },
        (err) => {
          this.error = err.error;
          this.pending = false;
        }
      );
  }
  goBack() {
    this.location.back();
  }
  getWalletDetails() {
    this.pending = true;
    this.error = null;
    this.walletService
      .getWalletDetails({
        nccId: this.organization.jpaContractor.nccId,
      })
      .subscribe(
        (res: any) => {
          res.ewalletActivated
            ? this.router.navigate(['/contractor/wallet/activate'])
            : '';
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  goToActivateWallet() {
    this.router.navigate(['/contractor/wallet/activate']);
  }
}
